import React, { Component } from 'react';
import CircularProgress from 'material-ui/CircularProgress';

import logo from '../../images/logoFlat.svg';
import Spinner from '../components/spinner';

class Signup extends Component {
    render () {
        const {email, password, rePassword} = this.props.input;

        if (this.props.loading) {
            return (
                <div className='auth-background signup flex'>
                    <Spinner />
                </div>
            );
        }

        return (
            <div className='auth-background signup'>
                <div className='auth-logo-wrapper'>
                    <img className='auth-logo' src={logo} alt='logo' />
                </div>
                <br />
                <br />
                <br />
                <div className='input-field-wrapper'>
                    {/* <img src={inputText} className='input-field-background' /> */}
                    {/* <div className='input-field-inner-wrapper'> */}
                    <input type='email' name='email' placeholder='Email' className='input-field' onChange={(e) => this.props.inputChanged('email', e.target.value)} />
                    {/* </div> */}
                </div>

                <ErrorRenderer condition={this.props.emailError !== null} message={this.props.emailError} />

                <div className='input-field-wrapper'>
                    {/* <img src={inputText} className='input-field-background' /> */}
                    {/* <div className='input-field-inner-wrapper'> */}
                    <input type='password' placeholder='Senha' className='input-field' onChange={(e) => this.props.inputChanged('password', e.target.value)} />
                    {/* </div> */}
                </div>

                <div className='input-field-wrapper'>
                    {/* <img src={inputText} className='input-field-background' /> */}
                    {/* <div className='input-field-inner-wrapper'> */}
                    <input type='password' placeholder='Repita a senha' className='input-field' onChange={(e) => this.props.inputChanged('rePassword', e.target.value)} />
                    {/* </div> */}
                </div>

                <ErrorRenderer condition={this.props.passwordError !== null} message={"Campo de senha vazio, preencha-o e tente novamente."} />
                <ErrorRenderer condition={this.props.error && this.props.error.message === 'That email is already taken.'} message={"Usuário ja existe!"} />
                <ErrorRenderer condition={this.props.passwordMatchError} message={"Senhas não batem."} />
                <ErrorRenderer
                    condition={this.props.error}
                    message={this.props.error} />

                <div className='container-buttons'>
                    <div className='btn block login'
                        onClick={() => {
                            if (this.props.match.params.id) {
                                this.props.signupInvitedUser({email, password, rePassword}, this.props.match.params.id);
                            } else {
                                this.props.signupUser({email, password, rePassword});
                            }
                        }}>
                        <h4>Cadastrar</h4>
                    </div>
                </div>
                <div className='container-buttons' >
                    <div className='btn block login'
                        onClick={() => this.props.history.push('/')} >
                        <h4>Já possuo conta</h4>
                    </div>
                </div>
            </div>
        );
    }
}

const ErrorRenderer = (props) => (
    <div className='auth-error-container'>
        <div className='auth-error-wrapper'>
            {
                props.condition
                ? <span className='auth-error-message'>{props.message}</span>
                : null
            }
        </div>
    </div>
);

export default Signup;



// WEBPACK FOOTER //
// ./src/views/AuthViews/signupView.js